var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiBuildingArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 18.3337C2.8763 18.3337 2.48394 18.1705 2.15755 17.8441C1.83116 17.5177 1.66797 17.1253 1.66797 16.667V9.41699C1.66797 9.08366 1.75825 8.7781 1.9388 8.50033C2.11936 8.22255 2.36936 8.01421 2.6888 7.87533L6.33464 6.33366C6.61241 6.22255 6.8763 6.24338 7.1263 6.39616C7.3763 6.54894 7.5013 6.7781 7.5013 7.08366V7.50033L10.5221 6.29199C10.7999 6.18088 11.0603 6.20866 11.3034 6.37533C11.5464 6.54199 11.668 6.77116 11.668 7.06283V8.33366H18.3346V16.667C18.3346 17.1253 18.1714 17.5177 17.8451 17.8441C17.5187 18.1705 17.1263 18.3337 16.668 18.3337H3.33464ZM3.33464 16.667H16.668V10.0003H10.0013V8.29199L5.83464 9.95866V8.33366L3.33464 9.43783V16.667ZM9.16797 15.0003H10.8346V11.667H9.16797V15.0003ZM5.83464 15.0003H7.5013V11.667H5.83464V15.0003ZM12.5013 15.0003H14.168V11.667H12.5013V15.0003ZM18.3346 8.33366H14.168L14.918 2.39616C14.9457 2.18783 15.036 2.01421 15.1888 1.87533C15.3416 1.73644 15.5221 1.66699 15.7305 1.66699H16.7721C16.9805 1.66699 17.161 1.73644 17.3138 1.87533C17.4666 2.01421 17.5569 2.18783 17.5846 2.39616L18.3346 8.33366Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiBuildingArea);
export default __webpack_public_path__ + "static/media/kpi-building-area.cbe030ef387479c9d0286de42b35fa80.svg";
export { ForwardRef as ReactComponent };